import { Link } from 'react-router-dom'
import taganga_202505 from './202505_taganga/foto_1.jpg'

export default function ApoyoEmpresarial() {
  const temas = [
    {
      nombre: 'Artesanos Taganga',
      imagen: taganga_202505,
      texto: 'Acompañamiento técnico-profesional dirigidos a artesanos de Santa Marta',
      ruta: '/galeria/apoyo-empresarial/taganga-202505',
    }
  ];

  return (
    <div className='container mt-4 text-center'>
      <div className='row justify-content-center '>
        <div className='pb-3'><h4>Galerias - Apoyo empresarial</h4></div>
        <div className='border-top border-3 mb-3'></div>
        {temas.map((t, i) => (
          <div key={i} className='col-12 col-sm-6 col-md-4 col-lg-2 mb-4'>
            <Link to={t.ruta} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card h-100">
                <img src={t.imagen} className="card-img-top" alt={t.nombre} />
                <div className="card-body">
                  <h6 className="fw-bold">{t.nombre}</h6>
                  <p className="card-text">{t.texto}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
